export default __webpack_public_path__ + "static/media/M2HairSalon-2.283324c8.jpg";